import { History, createBrowserHistory } from "history";

let historyObject: History<any> | null;

export function getHistory(): History<any> {
    if (!historyObject) {
        historyObject = createBrowserHistory();
    }
    return historyObject!;
}
